import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  dataPlaceholder: {
    padding: theme.spacing(40, 20),
    textAlign: 'center',
  },
  text: {
    fontSize: 16,
    marginTop: theme.spacing(8),
  },
}));
